import axios from 'axios'
import { serializeParams } from '../utils/genericUtils.js'
export default {
  namespaced: true,
  actions: {
    getRoundsXlsx(_, params) {
      return axios({
        headers: {
          Accept: 'application/octet-stream',
          'Content-Type': 'application/octet-stream',
        },
        url: `${process.env.VUE_APP_URL}/round/report/xlsx`,
        method: 'GET',
        responseType: 'blob',
        params,
      })
    },
    getRoundsPdf(_, params) {
      return axios({
        headers: {
          Accept: 'application/octet-stream',
          'Content-Type': 'application/octet-stream',
        },
        url: `${process.env.VUE_APP_URL}/round/report/pdf`,
        method: 'GET',
        responseType: 'blob',
        params,
      })
    },
    getRounds(_, filters) {
      return axios({
        url: `${process.env.VUE_APP_URL}/round/web/getRounds`,
        method: 'GET',
        params: filters,
      })
    },
    confirmRound(o, round) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/round/web/confirmRound',
          method: 'PUT',
          data: round,
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getRound(o, round) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/round/web/getSingle',
          method: 'POST',
          data: round,
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    deleteRound(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/round/web',
          method: 'DELETE',
          data: obj.enviar,
        })
          .then((response) => {
            if (response) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    deleteInvitation(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            process.env.VUE_APP_URL +
            '/round/web/' +
            obj.idRound +
            '/invitations',
          method: 'DELETE',
          data: obj.enviar,
        })
          .then((response) => {
            if (response) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getCollegeRounds(_, params) {
      return axios({
        url: `${process.env.VUE_APP_URL}/round/web`,
        method: 'GET',
        params,
      })
    },
    getParentsRound(_, params) {
      return axios({
        url: `${process.env.VUE_APP_URL}/round/web/parents${serializeParams(
          params
        )}`,
        method: 'GET',
      })
    },
    getDetailRound(_, idRound) {
      return axios({
        url: `${process.env.VUE_APP_URL}/round/web/${idRound}`,
        method: 'GET',
      })
    },
    getDetailStudentsRound(_, { idRound, params } = {}) {
      return axios({
        url: `${
          process.env.VUE_APP_URL
        }/round/web/${idRound}/invitations${serializeParams(params)}`,
        method: 'GET',
      })
    },
    getDetailTutorRound(_, { idRound, params } = {}) {
      return axios({
        url: `${
          process.env.VUE_APP_URL
        }/round/web/${idRound}/parents${serializeParams(params)}`,
        method: 'GET',
      })
    },
    createCollegeRound(_, data) {
      return axios({
        url: `${process.env.VUE_APP_URL}/round/web`,
        method: 'POST',
        data,
      })
    },
    editCollegeRound(_, { idRound, data } = {}) {
      return axios({
        url: `${process.env.VUE_APP_URL}/round/web/${idRound}`,
        method: 'PUT',
        data,
      })
    },
    deleteCollegeRound(_, idRound) {
      return axios({
        url: `${process.env.VUE_APP_URL}/round/web/${idRound}`,
        method: 'DELETE',
      })
    },
    getCollegeRoundsPdf(_, params) {
      return axios({
        headers: {
          Accept: 'application/octet-stream',
          'Content-Type': 'application/octet-stream',
        },
        url: `${process.env.VUE_APP_URL}/round/web/report/pdf`,
        method: 'GET',
        responseType: 'blob',
        params,
      })
    },
    getCollegeRoundsXlsx(_, params) {
      return axios({
        headers: {
          Accept: 'application/octet-stream',
          'Content-Type': 'application/octet-stream',
        },
        url: `${process.env.VUE_APP_URL}/round/web/report/xlsx`,
        method: 'GET',
        responseType: 'blob',
        params,
      })
    },
  },
}
